import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { N0 } from '@atlaskit/theme/colors';
import camelCase from 'lodash/camelCase';
import orderBy from 'lodash/orderBy';
import React from 'react';
import { chartLineStyles } from '../Common/ChartUtils';
import { formatChartData } from '../PartnerReports.utils';
import SalesOrEvaluationsTableContent, { apiHeadToHeaderConfigMap, headerConfigToAPIHeadMap } from './SalesOrEvaluationsTable/SalesOrEvaluationsTableContent';
import { headerConfigBasedOnReportBy } from './SalesOrEvaluationsTable/SalesOrEvaluationsTableHead';
import { formatTooltipValue } from './SalesOrEvaluationsTable/SalesTableContent.utils';
export const getAggregatedCount = apps => {
  return apps.reduce((previousValue, currentValue) => {
    var _currentValue$revenue, _currentValue$netCoun, _currentValue$count;
    previousValue.revenue += (_currentValue$revenue = currentValue.revenue) !== null && _currentValue$revenue !== void 0 ? _currentValue$revenue : 0;
    previousValue.salesCount += (_currentValue$netCoun = currentValue.netCount) !== null && _currentValue$netCoun !== void 0 ? _currentValue$netCoun : 0;
    previousValue.evaluations += (_currentValue$count = currentValue.count) !== null && _currentValue$count !== void 0 ? _currentValue$count : 0;
    return previousValue;
  }, {
    revenue: 0,
    salesCount: 0,
    evaluations: 0
  });
};
export const getElements = (series, name) => {
  var _series$find$elements, _series$find;
  return (_series$find$elements = (_series$find = series.find(item => item.name === name)) === null || _series$find === void 0 ? void 0 : _series$find.elements) !== null && _series$find$elements !== void 0 ? _series$find$elements : [];
};
const calculateSalesAndRevenueForALlCountries = series => series.map(item => _objectSpread(_objectSpread({}, item), getAggregatedCount(item.elements)));
const calculateOthersAndIncludeTopThreeCountries = sortedColumnsData => {
  // Others will calculated only if there are more than 3 countries
  if (sortedColumnsData.length <= 3) {
    /* This is to fill empty revenue in case the total countries
       are less than the required of columns in the table */
    return [...sortedColumnsData, ...new Array(headerConfigBasedOnReportBy.country.length - sortedColumnsData.length).fill({
      name: '',
      revenue: 0,
      salesCount: 0,
      evaluations: 0,
      elements: []
    })];
  }

  // Top 3 grossing countries
  const topThree = sortedColumnsData.splice(0, 3);

  // Calculate Sales & Revenue for all countries the other than top 3
  const others = {
    name: 'Others',
    revenue: 0,
    salesCount: 0,
    evaluations: 0,
    elements: []
  };
  sortedColumnsData.reduce((othersTotal, country) => {
    othersTotal.revenue += country.revenue;
    othersTotal.salesCount += country.salesCount;
    othersTotal.evaluations += country.evaluations;
    return othersTotal;
  }, others);
  return [...topThree, others];
};
const getSortedCountries = (series, reportName) => {
  // All countries sorted by revenue(sales) or evaluations in descending order
  const sortedColumnKey = reportName === 'sales' ? 'revenue' : 'evaluations';
  return orderBy(calculateSalesAndRevenueForALlCountries(series), [sortedColumnKey], ['desc']);
};
const getColumnsForCountry = function getColumnsForCountry(series, reportName) {
  let isSummaryContent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const sortedCountries = getSortedCountries(series, reportName);
  const topGrossing = calculateOthersAndIncludeTopThreeCountries(sortedCountries);
  return topGrossing.map(country => ({
    revenue: country.revenue,
    salesCount: country.salesCount,
    evaluations: country.evaluations,
    country: country.name,
    // Table columns will be sorted based on Revenue(in sales) Or Evaluations.
    key: country.revenue || country.evaluations,
    content:
    /*#__PURE__*/
    React.createElement(SalesOrEvaluationsTableContent, {
      revenue: country.revenue,
      salesCount: country.salesCount,
      evaluations: country.evaluations,
      country: country.name,
      isSummaryContent: isSummaryContent
    })
  }));
};
const getColumnsForOther = function getColumnsForOther(series, appKey, reportBy) {
  let isSummaryContent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return headerConfigBasedOnReportBy[reportBy].map(head => {
    const elements = getElements(series, headerConfigToAPIHeadMap[head] || head);
    const {
      revenue,
      salesCount,
      evaluations
    } = getAggregatedCount(elements);
    return {
      revenue,
      salesCount,
      evaluations,
      // Table columns will be sorted based on Revenue(in sales) Or Evaluations.
      key: revenue || evaluations,
      content:
      /*#__PURE__*/
      React.createElement(SalesOrEvaluationsTableContent, {
        revenue: revenue,
        salesCount: salesCount,
        reportByValue: head,
        reportBy: reportBy,
        appKey: appKey,
        evaluations: evaluations,
        isSummaryContent: isSummaryContent
      })
    };
  });
};
export const deriveLinePatternMapper = (reportName, reportBy, totalSeries, canUseLinePatterns) => {
  const mapper = new Map();
  if (reportBy === 'country') {
    if (totalSeries.length > 0) {
      const sortedCountries = getSortedCountries(totalSeries, reportName);
      const topGrossing = calculateOthersAndIncludeTopThreeCountries(sortedCountries);
      for (let i = 0; i < topGrossing.length; i++) {
        const linePattern = canUseLinePatterns ? chartLineStyles[i] : {
          color: chartLineStyles[i].color
        };
        mapper.set(topGrossing[i].name, linePattern);
      }
    }
  } else {
    const configs = headerConfigBasedOnReportBy[reportBy];
    configs.forEach((config, index) => {
      const linePattern = canUseLinePatterns ? chartLineStyles[index] : {
        color: chartLineStyles[index].color
      };
      mapper.set(config, linePattern);
      const apiHead = headerConfigToAPIHeadMap[config];
      if (apiHead) {
        mapper.set(apiHead, linePattern);
      }
    });
  }
  return key => mapper.get(key) || {
    color: N0
  };
};
export const getReportColumnsForSeries = _ref => {
  let {
    series,
    reportName,
    reportBy,
    appKey,
    isSummaryContent = false
  } = _ref;
  const columns = reportBy === 'country' ? getColumnsForCountry(series, reportName, isSummaryContent) : getColumnsForOther(series, appKey, reportBy, isSummaryContent);
  const total = {
    revenue: 0,
    salesCount: 0,
    evaluations: 0
  };
  columns.reduce((newTotal, cell) => {
    newTotal.revenue += cell.revenue;
    newTotal.salesCount += cell.salesCount;
    newTotal.evaluations += cell.evaluations;
    return newTotal;
  }, total);
  columns.push(_objectSpread(_objectSpread({
    key: total.revenue || total.evaluations
  }, total), {}, {
    name: "All ".concat(reportName === 'sales' ? 'sales' : 'evaluations'),
    content:
    /*#__PURE__*/
    React.createElement(SalesOrEvaluationsTableContent, {
      revenue: total.revenue,
      salesCount: total.salesCount,
      evaluations: total.evaluations,
      appKey: appKey,
      isSummaryContent: isSummaryContent
    })
  }));
  return columns;
};
export const getSalesOrEvaluationsTableData = (reportApps, reportName, reportBy, allReportingApps) => {
  const tableData = reportApps.map(app => ({
    appKey: app.addonKey,
    appName: app.name,
    columns: getReportColumnsForSeries({
      series: app.series,
      reportName,
      reportBy,
      appKey: app.addonKey
    })
  }));
  allReportingApps.forEach(app => {
    if (!tableData.some(entry => entry.appKey === app.appKey)) {
      tableData.push({
        appKey: app.appKey,
        appName: app.appName,
        columns: getReportColumnsForSeries({
          series: [],
          reportName,
          reportBy,
          appKey: app.appKey
        })
      });
    }
  });
  return tableData;
};
const calculateOthersAndIncludeTopThreeCountriesForCharts = sortedCountries => {
  // Top 3 grossing countries
  const topThree = sortedCountries.splice(0, 3);

  // Calculate total elements by date for all other countries apart from top 3
  const others = sortedCountries.reduce((prev, current) => {
    prev.elements = prev.elements.map((element, index) => ({
      date: element.date,
      count: element.count + current.elements[index].count,
      netCount: (element.netCount || 0) + (current.elements[index].netCount || 0),
      revenue: (element.revenue || 0) + (current.elements[index].revenue || 0)
    }));
    return prev;
  });
  return [...topThree, {
    name: 'Others',
    elements: others.elements
  }];
};

/*
    Create Lines & Chart Data to be required
    Lines = [{color, dataKey, legend}]
    Chart Date = [[{ xLabel: date1, hosting: {} } ...], [{ xLabel: date1, server: {} } ...]]
 */
const getLinesAndChartData = (series, reportName, reportBy, units, LinePatternMapper) => {
  let lines = [];
  const twoDimensionalChartData = [];
  const salesDataKeyMap = {
    revenue: 'revenue',
    netCount: 'salesCount'
  };
  series.forEach(seriesItem => {
    const label = camelCase(seriesItem.name);
    const dataKey = reportName === 'sales' ? salesDataKeyMap[units] : 'evaluations';
    const linePattern = LinePatternMapper(seriesItem.name);
    lines.push({
      color: linePattern.color,
      dataKey: "".concat(label, ".").concat(dataKey),
      legend: apiHeadToHeaderConfigMap[seriesItem.name] || seriesItem.name,
      dotStyle: linePattern.dotStyle,
      strokeStyle: linePattern.strokeStyle
    });
    const singleChartDate = seriesItem.elements.map(element => ({
      xLabel: element.date,
      [camelCase(seriesItem.name)]: {
        revenue: element.revenue || 0,
        salesCount: element.netCount || 0,
        evaluations: element.count
      }
    }));
    twoDimensionalChartData.push(singleChartDate);
  });
  if (series.length > 0 && reportBy !== 'country') {
    headerConfigBasedOnReportBy[reportBy].forEach(config => {
      const key = headerConfigToAPIHeadMap[config] || config;
      const dataKey = reportName === 'sales' ? salesDataKeyMap[units] : 'evaluations';
      const stubArray = series[0].elements.map(element => ({
        xLabel: element.date,
        [camelCase(key)]: {
          revenue: 0,
          salesCount: 0,
          evaluations: 0
        }
      }));
      twoDimensionalChartData.push(stubArray);
      if (lines.find(line => line.legend === key) === undefined) {
        const label = camelCase(key);
        const linePattern = LinePatternMapper(key);
        lines.push({
          color: linePattern.color,
          dataKey: "".concat(label, ".").concat(dataKey),
          legend: config,
          dotStyle: linePattern.dotStyle,
          strokeStyle: linePattern.strokeStyle
        });
      }
    });

    // This is reordering the lines in a specific desired order
    lines = headerConfigBasedOnReportBy[reportBy].map(config => lines.find(line => line.legend === config));
  }
  return {
    lines,
    chartData: twoDimensionalChartData
  };
};
export const getChartData = (totalSeries, reportName, reportBy, units, LinePatternMapper) => {
  if (reportBy === 'country' && totalSeries.length > 3) {
    const sortedCountries = getSortedCountries(totalSeries, reportName);
    totalSeries = calculateOthersAndIncludeTopThreeCountriesForCharts(sortedCountries);
  }
  const linesAndChartData = getLinesAndChartData(totalSeries, reportName, reportBy, units, LinePatternMapper);
  return {
    lines: linesAndChartData.lines,
    data: formatChartData(linesAndChartData.chartData)
  };
};
export const getChartTooltipPairs = (reportName, payload, lines) => {
  const total = {
    sales: 0,
    revenue: 0,
    evaluations: 0
  };
  const pairs = payload.map((item, index) => {
    const dataKey = item.dataKey.split('.')[0];
    const data = item.payload[dataKey];
    if (typeof data === 'object') {
      total.revenue += data.revenue;
      total.sales += data.salesCount;
      total.evaluations += data.evaluations;
      return {
        color: item.color,
        label: item.name,
        value: formatTooltipValue(reportName, data.revenue, data.salesCount, data.evaluations),
        isCharted: true,
        dotStyle: lines[index].dotStyle,
        strokeStyle: lines[index].strokeStyle
      };
    }
    return {
      label: '',
      value: ''
    };
  });
  pairs.push({
    label: "All ".concat(reportName),
    value: formatTooltipValue(reportName, total.revenue, total.sales, total.evaluations)
  });
  return pairs;
};

/*
 * This function will return Aggregated series for given app
 * If no app passed, will retutn total series
 */
export const getSeriesByAppName = (salesOrEvaluations, appKey) => {
  if (appKey) {
    const appKeySeries = salesOrEvaluations.addons.find(series => series.addonKey === appKey);
    const emptySeries = {
      name: '',
      series: []
    };
    return appKeySeries || emptySeries;
  }
  return salesOrEvaluations === null || salesOrEvaluations === void 0 ? void 0 : salesOrEvaluations.total;
};